import { c as _c } from "react/compiler-runtime";
// import CheckmarkIcon from "@/components/common/checkmark-icon/checkmark-icon";
import css from "./resource-key-list.module.scss";
interface IResourceKeyListProps {
  data: string[];
}
const ResourceKeyList = props => {
  const $ = _c(4);
  const {
    data
  } = props;
  let t0;
  if ($[0] !== data) {
    t0 = data.map(_temp);
    $[0] = data;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <ul className={css.resourceKeyList}>{t0}</ul>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default ResourceKeyList;
function _temp(item, i) {
  return <li key={i} className={css.resourceKeyListItem}><span className="">{item}</span></li>;
}